import { InputLabel, styled } from "@mui/material";

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    letterSpacing: "1px",
    fontWeight: 400,
    fontSize: "22px", // Uses dynamic font size from theme
    lineHeight: "120%",
    color:"black !important", 
    fontFamily: "Inter, sans-serif",
  }));